import { render, staticRenderFns } from "./bgaChangeList.vue?vue&type=template&id=55e5d874&scoped=true"
import script from "./bgaChangeList.vue?vue&type=script&lang=js"
export * from "./bgaChangeList.vue?vue&type=script&lang=js"
import style0 from "./bgaChangeList.vue?vue&type=style&index=0&id=55e5d874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5d874",
  null
  
)

export default component.exports